/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
import _ from 'lodash';
/* Package JSON Import will be here */

/* Project Import will be here */
import CreateTaskGroupComponent from './createTaskGroup.Component';
import { MessageBox } from '../../../sharedComponent/messageBox';
import { Constants } from '../../../../config/appConstants';
import { ApiUrls } from '../../../../services/api';
import Api from '../../../../services/api/serviceCall';
import { bindActionCreators } from 'redux';
import * as onHistorySaveAction from '../../../../actions/history.Action';

/* Const,Let & Var will be here */

class CreateTaskGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allTaskList: [],
            selectedTaskList: [],
            selectedTasks: [],
            grpName: '',
            savedGroupName: '',
            grpList: [],
            groupId: this.props.location && this.props.location.state && this.props.location.state.groupId ? this.props.location.state.groupId : 0,
            projectId: this.props.location && this.props.location.state && this.props.location.state.projectId ? this.props.location.state.projectId : 0,
            projectNumber: this.props.location && this.props.location.state && this.props.location.state.projectNumber ? this.props.location.state.projectNumber : 0,
            selectedTaskFromEmployee: this.props.location && this.props.location.state && this.props.location.state.selectedTask ? this.props.location.state.selectedTask : "",
            alreadySelectedTasks: [],
            searchText: "",
            isShowSaveConfirmation: false,
            isShowLoader: false,
            selectedDate: this.props.location && this.props.location.state && this.props.location.state.selectedDate ? this.props.location.state.selectedDate : new Date(),
            isDeleteConfirmationPopupVisible: false,
            selectedEmployeeList: this.props.location && this.props.location.state && this.props.location.state.selectedEmployeeList ? this.props.location.state.selectedEmployeeList : "",
            existGrpTask:[]
        };
    };

    componentDidMount() {
        this.props.onHistorySave(window.location.pathname);
        // Bug #279 - If user Unselect a Tascode which is avaliable for a Project, the Unselected Taskcode is changing the place
        // If we need task arrangement in future we need to rollback this change set
        let { groupId} = this.state;
        if (groupId > 0) {
            this.getSelectedTskGroup();
        }
        else{
        this.getTaskList();
        }
    }

    componentWillUnmount(){
        if(this.props.history.action === "POP"){
            this.props.history.push('/AddTimeCard', {selectedEmployeeList: this.state.selectedEmployeeList})
        }
    }

    getTaskList() {
        let {projectId, projectNumber,allTaskList } = this.state;
        let requestData = (this.state.searchText) ? {
            SearchText: [
                { fieldName: "projectTaskName", value: this.state.searchText }
            ]
        } : {};
        let url = `${ApiUrls.Routes.PJT_C}${ApiUrls.Routes.GT_AAPTKBDID_M}?projectId=${projectId}&projectNumber=${projectNumber}`;
        Api.Post(url, requestData, this, false).then((responseData) => {
            try {
                if (responseData.success && responseData.data) {
                    let{existGrpTask} = this.state;
                    if (!this.state.searchText && existGrpTask.length > 0) {
                        existGrpTask.sort((a, b) => (a.taskNumber > b.taskNumber) ? 1 : -1);
                      var taskNotInGroup = responseData.data.sort((a, b) => (a.taskNumber > b.taskNumber) ? 1 : -1);

                      allTaskList = JSON.parse(JSON.stringify(existGrpTask));
                        taskNotInGroup.map(a => {
                            if(!allTaskList.find(b => b.taskName === a.taskName && b.taskNumber === a.taskNumber)){
                                allTaskList.push(a);
                            }
                        });
                    }
                    else{
                        allTaskList = responseData.data.sort((a, b) => (a.taskNumber > b.taskNumber) ? 1 : -1);
                    }
                    this.setState({ allTaskList });
                }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });

    }

    getSelectedTskGroup() {
        let { selectedTaskList, grpName,selectedTasks} = this.state;
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_TSK_GRP_BY_GRP_ID_M}?deviceId=${this.props.device.deviceId}&&groupId=${this.state.groupId}`;
        Api.Get(url, this, false).then((responseData) => {
            try {
                if (responseData.success && responseData.data) {
                    let selectedTsk = responseData.data.data;
                    if (selectedTsk) {
                        grpName = selectedTsk[0].groupName;

                        selectedTsk.map((t) => {
                            selectedTaskList.push({
                                id: Number(t.taskCodeID),
                                taskName: t.taskName,
                                taskNumber: t.taskNumber
                            });
                            selectedTasks.push({
                                id: Number(t.taskCodeID),
                                taskName: t.taskName,
                                taskNumber: t.taskNumber
                            });
                        });
                        selectedTasks.sort((a, b) => (a.taskNumber > b.taskNumber) ? 1 : -1);
                        this.setState({ selectedTaskList, selectedTasks, grpName, savedGroupName: grpName, alreadySelectedTasks: selectedTsk, existGrpTask: JSON.parse(JSON.stringify(selectedTaskList))},
                            () => {
                                this.getTaskList();
                            });
                    }
                    }
                else {
                    MessageBox(responseData.message, Constants.ERROR);
                }
            }
            catch (err) {
                MessageBox(err.message, Constants.ERROR);
            }
        });
    }

    onClickSave() {
        let { grpName, selectedTaskList, groupId, alreadySelectedTasks } = this.state;
        if (grpName.trim() === '') {
            MessageBox(Constants.ENTER_FAVORITES_GROUP_NAME, Constants.ERROR);
            this.setState({
                isShowSaveConfirmation: false
            });
            return;
        }
        if (selectedTaskList.length === 0) {
            MessageBox(Constants.SELECT_ONE_OR_MORE_TO_GROUP.replace("{0}", "tasks"), Constants.ERROR);
            this.setState({
                isShowSaveConfirmation: false
            });
            return;
        }
        var tskIds = [];
        if (groupId === 0) {
            selectedTaskList.map((a) => {
                tskIds.push({
                    TaskId: a.id,
                    IsActive: true
                })
            });
        }
        else {
            selectedTaskList.map((a) => {
                tskIds.push({
                    TaskId: a.id,
                    IsActive: true
                })
            });
            // Adding existing task codes which are all unselected
            alreadySelectedTasks && alreadySelectedTasks.filter(e =>
                !selectedTaskList.some(a =>a.id === Number(e.taskCodeID) && a.taskName === e.taskName && a.taskNumber === e.taskNumber)).map((t) => {
                    tskIds.push({
                        TaskId: Number(t.taskCodeID),
                        IsActive: false
                    })
                });
        }
        let requestData = {
            GroupId: groupId,
            DeviceID: this.props.device.deviceId,
            GroupName: grpName,
            TaskIds: tskIds
        }
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.SV_TSK_GRP_M}`;
        Api.Post(url, requestData, this).then((response) => {
            if (response.success) {
                MessageBox(response.message, Constants.SUCCESS);
                this.setState({
                    isShowSaveConfirmation: false
                });
                this.props.history.push("/AddTimeCard", { selectedDate: this.state.selectedDate, selectedTask: this.state.selectedTaskFromEmployee, selectedEmployeeList: this.state.selectedEmployeeList });
            }
            else {
                MessageBox(response.message, Constants.ERROR);
            }
        });
    }

    onSearch(event) {
        this.setState({ searchText: event.target.value },
            () => {
                this.getTaskList();
            });
    }

    onTaskSelect(taskId, taskNumber, taskName,data) {
        let { selectedTaskList ,allTaskList,selectedTasks} = this.state;
        let selectedTask = allTaskList.find(t => t.taskName === taskName && t.taskNumber === taskNumber);
        if (selectedTaskList.findIndex(t => t.taskName === taskName && t.taskNumber === taskNumber) < 0) {
            selectedTaskList.push({
                id: Number(taskId),
                taskName : taskName,
                taskNumber: taskNumber
            });
        }
        else {
            var index = selectedTaskList.findIndex(t => t.taskName === taskName && t.taskNumber === taskNumber);
            selectedTaskList.splice(index, 1);
        }
        if (selectedTask && data.checked && !selectedTasks.find(t => t.taskName === taskName && t.taskNumber === taskNumber)) {
            selectedTasks.push({
                id: Number(selectedTask.id),
                taskName : selectedTask.taskName,
                taskNumber: selectedTask.taskNumber
            });
         }
         else if(selectedTasks.find(t => t.taskName === taskName && t.taskNumber === taskNumber)){
            selectedTasks.splice(selectedTasks.indexOf(selectedTasks.find(t => t.taskName === taskName && t.taskNumber === taskNumber)), 1);
         }
        this.setState({ selectedTaskList ,selectedTasks});
    }

    handleChangeGrpName = (event) => {
        let { grpName } = this.state;
        grpName = event.target.value;
        this.setState({
            grpName
        });
    }

    onClickDelete() {
        this.setState({
            isDeleteConfirmationPopupVisible: true
        });
    }

    onDeleteClickInConfirmationPopup() {
        let { groupId } = this.state;
        let url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.DL_TSK_GRP_M}?groupId=${groupId}&deviceId=${this.props.device.deviceId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData.success) {
                MessageBox(responseData.data.message, Constants.SUCCESS);
                this.props.history.push("/AddTimeCard", { selectedTask: this.state.selectedTaskFromEmployee, selectedEmployeeList: this.state.selectedEmployeeList });
            }else{
                MessageBox(responseData.message,Constants.ERROR);
            }
        });
    }

    onCancelClickInConfirmationPopup() {
        this.setState({
            isDeleteConfirmationPopupVisible: false
        });
    }

    onClickBack() {
        const { grpName, savedGroupName, selectedTaskList, alreadySelectedTasks } = this.state;
        const selectedTaskCodeIds = selectedTaskList?.map(a => a.id).slice().sort((a, b) => a - b);
        const savedTaskCodeIds = alreadySelectedTasks?.map(a => +a.taskCodeID).slice().sort((a, b) => a - b);

        if (!_.isEqual(grpName, savedGroupName) || !_.isEqual(selectedTaskCodeIds, savedTaskCodeIds)) {
            this.setState({
                isShowSaveConfirmation: true
            });
        }
        else {
            this.goBack();
        }
    }

    onCloseModel() {
        this.setState({
            isShowSaveConfirmation: false
        });
        this.goBack();
    }

    goBack() {
        this.props.history.push("/AddTimeCard", { selectedTask: this.state.selectedTaskFromEmployee, selectedEmployeeList: this.state.selectedEmployeeList });
    }

    render() {
        const { allTaskList, selectedTaskList,selectedTasks, grpName, groupId, alreadySelectedTasks, searchText, isShowSaveConfirmation, isShowLoader, isDeleteConfirmationPopupVisible } = this.state;
        return (
            <Fragment>
                <CreateTaskGroupComponent
                    {...{
                        createTaskGroup: {
                            allTaskList,
                            selectedTaskList,
                            selectedTasks,
                            grpName,
                            groupId,
                            alreadySelectedTasks,
                            searchText,
                            isShowSaveConfirmation,
                            isShowLoader,
                            isDeleteConfirmationPopupVisible
                        }
                    }}
                    onClickSave={this.onClickSave.bind(this)}
                    onSearch={this.onSearch.bind(this)}
                    onTaskSelect={this.onTaskSelect.bind(this)}
                    handleChangeGrpName={this.handleChangeGrpName.bind(this)}
                    onClickDelete={this.onClickDelete.bind(this)}
                    onClickBack={this.onClickBack.bind(this)}
                    onCloseModel={this.onCloseModel.bind(this)}
                    onDeleteClickInConfirmationPopup={this.onDeleteClickInConfirmationPopup.bind(this)}
                    onCancelClickInConfirmationPopup={this.onCancelClickInConfirmationPopup.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            onHistorySaveAction),
        dispatch);
}
export default withRouter(connect(mapStateToProps,mapDispatchToProps)(CreateTaskGroup));

CreateTaskGroup.displayName = 'CreateTaskGroup';